import { ClientError } from '@ricoh/ria.client.core/errors';
import { createServiceServerServiceConfigBase } from '@ricoh/ria.client.core/plugins/swr/common';
import { Url } from '@ricoh/ria.client.core/utils/es/url';

import type { ServiceServerServiceModule } from './_config.type';

/**
 * Resolve tenant.
 *
 * @returns {string} Tenant.
 */
function resolveTenant(): string {
  // * Remove trailing slash
  const webBase = import.meta.env.APP_CLIENT_WEB_BASE.replace(/\/$/g, '');

  // * Replace * with (.+?) -> to get tenant
  const originWithTenantResult = new RegExp(webBase.replace(/\*\./, '(.+?)\\.')).exec(globalThis.location.origin);
  if (!originWithTenantResult?.[1]) {
    // * Redirect to default tenant
    const originWithoutTenantResult = new RegExp(webBase.replace(/\*\./, '')).exec(globalThis.location.origin);
    if (originWithoutTenantResult) {
      const redirectOrigin = webBase.replace(/\*\./, `${import.meta.env.APP_CLIENT_WEB_DEFAULT_TENANT}.`);
      new Url(globalThis.location.href.replace(globalThis.location.origin, redirectOrigin)).redirect();
      return '';
    }

    throw new ClientError({
      module: 'core',
      message: 'Invalid web origin',
      cause: { origin: globalThis.location.origin },
    });
  }

  const tenant = originWithTenantResult[1];
  if (!tenant) {
    throw new ClientError({
      module: 'core',
      message: 'Invalid tenant',
      cause: { origin: globalThis.location.origin },
    });
  }

  return tenant;
}

/** ServiceServer config base. */
const serviceServerConfigBase = {
  options: createServiceServerServiceConfigBase.options({
    Tenant: resolveTenant(),
  }),

  createError: createServiceServerServiceConfigBase.createError<ServiceServerServiceModule>(),
};

export default serviceServerConfigBase;
